import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { FooterLabel_EN } from 'src/app/models/labels/footerLabel_EN';
import { FooterLabel_HN } from 'src/app/models/labels/footerLabel_HN';
import { BorrowerRenderingService } from 'src/app/services/borrower/borrower-rendering.service';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {

  label: any;

  constructor(public dialogRef: MatDialogRef<AboutUsComponent>, private borrowerRenderingService: BorrowerRenderingService) { }

  ngOnInit() {
    if (this.borrowerRenderingService.language) {
      if (this.borrowerRenderingService.language === 'ENGLISH') {
        this.label = new FooterLabel_EN();
      } else if (this.borrowerRenderingService.language === 'HINDI') {
        this.label = new FooterLabel_HN();
      }
    } else {
      this.label = new FooterLabel_EN();
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
